<template>
  <div>
    <b-modal id="modalGeofencesTrackingHistoryEvents" size="lg" ref="modalGeofencesTrackingHistoryEvents" hide-footer @hide="itemSelected = {}">
      <template #modal-title>
        <span v-translate="{geofence: itemSelected.external_id}">Tracking Events History for <strong>%{geofence}</strong></span><br>
        <small>{{ itemSelected.name }} ({{itemSelected.reference_location}})</small>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <tracking-history-events :item="itemSelected" />
    </b-modal>
  </div>
</template>

<script>
import TrackingHistoryEvents from '@/components/Geofences/TrackingHistoryEvents'

export default {
  name: 'GeofencesMixin',
  components: {
    TrackingHistoryEvents
  },
  data() {
    return {
      itemSelected: {}
    }
  },
  created() {
    this.$root.$on('Geofences::TrackingHistoryEvents::show', (item) => {
      this.itemSelected = item
      this.$bvModal.show('modalGeofencesTrackingHistoryEvents')
    })
  }
}
</script>
